import { render, staticRenderFns } from "./SendResetPasswordLinkToEmail.vue?vue&type=template&id=4fe6e16c&scoped=true"
import script from "./SendResetPasswordLinkToEmail.vue?vue&type=script&lang=js"
export * from "./SendResetPasswordLinkToEmail.vue?vue&type=script&lang=js"
import style0 from "./SendResetPasswordLinkToEmail.vue?vue&type=style&index=0&id=4fe6e16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6e16c",
  null
  
)

export default component.exports